export const PROJECT_EDITOR_DROPDOWN_KEY = 'PROJECT_EDITOR_DROPDOWN_KEY';
export const PROJECT_EDITOR_RATES_LIST_KEY = 'PROJECT_EDITOR_RATES_LIST_KEY';
